import { entityTargetPests } from '@user/components/Settings/EntityFormSettings/constants'
import { FieldSettingsMap } from '@user/store/entityFormSettings/typings'

type Props = {
  settingsMap: FieldSettingsMap
}

export function useData(props: Props) {
  const { settingsMap } = props

  const [requiredTargetPests, showTargetPests] = settingsMap.get(
    entityTargetPests,
  ) ?? [false, true]

  return { requiredTargetPests, showTargetPests }
}
